import nonCriticalException from './exceptionLogger';
import ng from './angularThings';

/**
 * Updates the URL to remove a query string parameter.
 */
export const removeQueryParameter = param => {
  try {
    const $state = ng.$injector.get('$state');
    delete $state.params[param];

    $state.go($state.current, $state.params, {
      location: 'replace',
      inherit: false,
      notify: false,
    });
  } catch (e) {
    nonCriticalException(e);
  }
};
